import ImageCropField from './Shared/ImageCropField';

interface ImageUploaderProps {
  currentImage?: string;
  onUpload: (file: File) => void;
  onDelete: () => void;
}

/**
 * Recortador de imagen para productos (recorte cuadrado, salida JPEG).
 *
 * El usuario arrastra el cursor sobre la imagen para marcar el área a
 * conservar.
 *
 * (Wrapper delgado sobre {@link ImageCropField} para no romper los consumidores.)
 */
const ImageUploader: React.FC<ImageUploaderProps> = ({
  currentImage,
  onUpload,
  onDelete,
}) => {
  return (
    <ImageCropField
      label="Imagen"
      currentImage={currentImage}
      aspect={1}
      mimeType="image/jpeg"
      outputName="product.jpg"
      onUpload={onUpload}
      onDelete={onDelete}
    />
  );
};

export default ImageUploader;
